// Helper function for timestamp formatting
import logger from './logger';
export const formatTimestamp = (timestamp) => {
  if (!timestamp) return 'now';
  
  try {
    let date;
    if (timestamp.toDate && typeof timestamp.toDate === 'function') {
      date = timestamp.toDate();
    } else if (timestamp instanceof Date) {
      date = timestamp;
    } else if (typeof timestamp === 'string' || typeof timestamp === 'number') {
      date = new Date(timestamp);
    } else {
      return 'now';
    }
    
    if (isNaN(date.getTime())) {
      return 'now';
    }
    
    const now = new Date();
    const diff = now - date;
    
    if (diff < 0) return 'now';
    if (diff < 60000) return 'now';
    if (diff < 3600000) return `${Math.floor(diff / 60000)}m`;
    if (diff < 86400000) return `${Math.floor(diff / 3600000)}h`;
    return `${Math.floor(diff / 86400000)}d`;
  } catch (error) {
    logger.error('Error formatting timestamp:', error);
    return 'now';
  }
};

// Basic sanitization helper to prevent XSS
export const sanitizeInput = (input) => {
  if (!input) return '';
  return String(input)
    .replace(/[<>]/g, '') // Remove < and > to prevent HTML injection
    .trim()
    .slice(0, 10000); // Limit length to prevent DOS
};